import { render } from "./RiskBasedMonitoring.vue?vue&type=template&id=4dc53083&scoped=true"
import script from "./RiskBasedMonitoring.vue?vue&type=script&lang=js"
export * from "./RiskBasedMonitoring.vue?vue&type=script&lang=js"

import "./RiskBasedMonitoring.vue?vue&type=style&index=0&id=4dc53083&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dc53083"]])

export default __exports__